import {GetMRTSRouteTask} from './GetMRTSRouteTask.js';
import {MRTSEndpoint} from './MRTSEndpoint.js';
import {isNil} from '@megaphonenpm/mputils/src/utils.js';
import {log} from '@megaphonenpm/mputils/src/logfunctions.js';
import {CHANGE} from '@megaphonenpm/mputils/src/constants.js';
import {get, isEqual} from 'lodash-es';

/**
 * Retrieves the latest MRTS endpoint configured for this MRTS client (at dataStore.mrtsEndpoint),
 * and compares it to the endpoint that is currently in use. If the two endpoints are different,
 * then CheckMRTSRouteTask dispatches a CHANGE event.
 *
 * The CheckMRTSRouteTask is used by MRTSEndpointMonitor to detect changes to the MRTS endpoint
 * for this MegaScreen. If the MRTS endpoint changes, MRTSEndpointMonitor forces this MRTS client to
 * disconnect from MRTS at the current location, then reconnect to MRTS at the new location.
 */
export class CheckMRTSRouteTask extends GetMRTSRouteTask {
  constructor (dataStore) {
    super();
    this.name = "CHECK_MRTS_ROUTE";
    this.dataStore = dataStore;
  }

  /**
   * When the MRTS route loads, compare the current and new endpoints. If they are different,
   * dispatch a CHANGE event.
   *
   * @param route
   */
  onMRTSRouteLoadSuccess (route) {
    let currentEndpoint = this.dataStore.mrtsEndpoint;
    let newEndpoint = new MRTSEndpoint(get(route, 'mrts.server'), get(route, 'mrts.ports'));
    let endpointChanged = false;

    log(`Current MRTS endpoint: ${get(currentEndpoint, 'host')} [${get(currentEndpoint, 'ports')}]`);
    log(`New MRTS endpoint: ${newEndpoint.host} [${newEndpoint.ports}]`);

    // Check if the MRTS endpoint has changed
    if (newEndpoint.isValid()) {
      if ((isNil(currentEndpoint) || !currentEndpoint.isValid())) {
        endpointChanged = true;
      } else {
        if (currentEndpoint.host !== newEndpoint.host) {
          endpointChanged = true;
        } else if (!isEqual(currentEndpoint.ports, newEndpoint.ports)) {
          endpointChanged = true;
        }
      }
    }

    // If the MRTS endpoint has changed, dispatch a CHANGE event
    if (endpointChanged) {
      this.dispatchEvent(CHANGE, {current: currentEndpoint, new: newEndpoint});
    } else {
      log('MRTS endpoint has not changed.');
    }

    this.done();
  }
}